<template>
    <div class="account-request">
        <!-- <SearchField
			class="search"
            :loading="loading"
			v-model="keyword"
            @input="changeFilter(true)"
		/>

        <RegisteredAccountControl class="controls"/>

        <DataTable
            :header="listTableHeader"
            :rows="list.data"
            :cells="[
                'request_date', 'company_name', 'full_name', 'email', 'country', 'full_contact_no',
                'subscription_start', 'subscription_end', 'status', 'is_disabled'
            ]"
            :clickable="true"
            :loading="loading"
            :hasNumberColumn="true"
            @select="select($event)"
            @rowClick="$router.push(`/account-overview/${$event.id}`)"
            :selectedItem="selectedAccounts"
            ref="dataTable"
        />

        <Pagination
			class="paginate"
			v-model="params.page"
			:currentPage="parseInt(params.page)"
			:total="list.total"
			:loading="loading"
            :hasPageCount="false"
		/> -->


        <data-container>
            <template slot="controls">
                <SearchField
                    class="search"
                    :loading="loading"
                    v-model="keyword"
                    @input="changeFilter(true)"
                />

                <div class="control-wrapper">
                    <div class="controls">
						<custom-option
							class="option"
							:options="filterOptions"
							placeholder="Filter by"
							v-model="params.filterBy"
						>
						</custom-option>

						<custom-option
							class="option"
							:options="sortOptions"
							placeholder="Sort by"
							v-model="params.sortBy"
						>
                        </custom-option>

                        <!-- <custom-option
							class="option"
							:options="['All']"
                            placeholder=""
                            value="All"
						>
                        </custom-option> -->


                    </div>

                    <RegisteredAccountControl class="controls"/>
                </div>
            </template>

            <template slot="content">
                <custom-table
                    :fields="fields"
					:items="list.data"
					:current-page="parseInt(params.page)"
					:items-per-page="10"
					:total-count="list.total"
                    hide-per-page-option
                    :is-loading="loading"
					:selected-items="selectedAccounts"
					@changePage="changePage"
                    @click="$router.push(`/account-overview/${$event.id}`)"
                >
                    <template #actions="{item}">
                        <button class="edit" @click.stop="editAccount(item)">
                            <img src="@/assets/img/icon/edit-alt.svg" alt="" class="icon">
                        </button>
                        <button @click.stop="remoteAccount(item)">
                            <img src="@/assets/img/icon/cloud-database-tree.svg" alt="" class="icon remote">
                        </button>
                        <!-- <button class="_deny" @click.stop="deleteAccount(item)">
                            <img src="@/assets/img/icon/trash.svg" alt="" class="icon">
                        </button> -->
                    </template>
                </custom-table>
            </template>
        </data-container>

        <transition name="transition-anim">
            <Modal v-if="modalName.indexOf('account-form') > -1">
                <AccountForm storeModule="registeredAccount" slot="content"/>
            </Modal>
        </transition>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as registeredAccount from '@/store/registered-account/app.js'

import SearchField from '@/components/utils/SearchField'
import CustomOption from '@/components/utils/CustomOption.vue'

import CustomTable from '@/components/utils/CustomTable.vue'
import DataContainer from '@/components/layouts/DataContainer.vue'

import RegisteredAccountControl from '@/components/registered-account/RegisteredAccountControl'
import AccountForm from '@/components/layouts/AccountForm'
export default {
    data () {
        return {
            fields: [
                {text: 'Acc. ID', name: 'id'},
				{text: 'Subscription Start', name: 'subscription_start'},
				{text: 'Expiry Date', name: 'subscription_end'},
				{text: 'Company Name', name: 'company_name'},
				{text: `Host Name`, name: 'full_name'},
				{text: 'Email', name: 'email'},
                {text: 'User', name: 'user_allocation'},
                {text: 'Status', name: 'status'}
                // {text: 'Account Status', name: 'is_disabled'}
            ],
            
            sortOptions: ['Latest', 'Oldest'],

            filterOptions: ['Active', 'Disabled'],
            fromPagination: false
        }
    },

    beforeCreate () {
        if (!this.$store._modulesNamespaceMap['registeredAccount/']) {
			this.$store.registerModule('registeredAccount', registeredAccount.default)
		}
    },

    async created () {
        await this.setParams()
    },

    destroyed () {
        this.$store.commit('registeredAccount/clearPage')
    },

    computed: {
        ...mapFields('registeredAccount', [
            'keyword',
            'params',
            'list',
            'loading',
            'selectedAccounts',
            'hasUpdatedList'
        ]),

        ...mapFields('modal', [
            'modalName',
        ]),
        
        // listTableHeader () {
		// 	return [
		// 		'Request date',
		// 		'Company Name',
		// 		`Host Name`,
		// 		'Email',
		// 		'Country',
		// 		'Contact No.',
		// 		'Subscription Start',
		// 		'Subscription End',
        //         'Status',
        //         'Account Status'
		// 	]
		// },
    },

    watch: {
        '$route.fullPath': {
            handler: 'getList',
            immediate: true
        },

        params: {
            handler () {
                this.changeFilter()
            },
            
            deep: true
        }
    },

    methods: {
        /* Created Lifecycle Method */
        setParams () {
            if (Object.keys(this.$route.query).length) {
                this.params = JSON.parse(JSON.stringify(this.$route.query))

                if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
            }
		},
		
		changePage ({ currentPage }) {
            this.params.page = currentPage
            this.fromPagination = true
		},

        /* Watcher Methods */
        getList (value) {
            if (this.hasUpdatedList) return
            
            let url = value.replace('/registered-accounts', '/cms/client/list')

            url += Object.keys(this.$route.query).length
                    ? '&account_status=1'
                    : '?account_status=1'

            this.$store.dispatch('registeredAccount/getAccountList', url)
        },

        async changeFilter () {
			if (!this.fromPagination) {
                this.params.page = 1
                this.selectedAccounts = []
			}

            const queryParams = {}
            const routeQuery = this.$route.query

			if (this.keyword) queryParams.keyword = this.keyword
			if (this.params.filterBy) queryParams.filter_by = this.params.filterBy.toLowerCase()
			if (this.params.sortBy) queryParams.order_by = this.params.sortBy.toLowerCase()
			if (this.params.page) queryParams.page = this.params.page

            let isNewParams = true

            if (Object.keys(routeQuery).length === Object.keys(queryParams).length) {
                isNewParams = false

                // Doing this since when on refresh, and there
                // is a $route.query e.g. ('?keyword=sample')
                // it will be assigned to this.params, and will trigger
                // param watcher and could generate a duplicate router push error
                for (const param of Object.keys(queryParams)) {
                    if (`${routeQuery[param]}` !== `${queryParams[param]}`) {
                        isNewParams = true
                        break
                    }
                }
            }
            
            if (isNewParams) this.$router.push({query: queryParams})
            this.fromPagination = false
        },

        editAccount ({ id }) {
            this.$router.push(`/registered-accounts/edit/${id}`)
        },

        remoteAccount ({id}) {
            let routeData = this.$router.resolve({name: 'session', params: {clientId: id}, query: {client_id: id, type: 'non-archived'}});
            window.open(routeData.href, '_blank');
        },

        // deleteAccount ({ id, is_disabled }) {
		// 	const toEnableAccount = is_disabled !== 'Enable'
        //     const form = new FormData()
        //     form.append('id', id)
        //     form.append('account_status', 1)
        //     form.append('is_disabled', toEnableAccount ? 0 : 1)

        //     this.$store.commit('modal/toggleModal', {
        //         modalType: 'warning',
        //         modalName: 'confirm-modal',
        //         modalDesc: `Are you sure you want to ${ toEnableAccount ? 'enable' : 'disable' } this account(s)?`,
        //         storeAction: 'registeredAccount/enableDisableAccount',
        //         storePayload: form
		// 	})
		// }
	},

    components: {
        CustomTable,
        DataContainer,
        CustomOption,
        SearchField,
        RegisteredAccountControl,

        Modal: () => import('@/components/utils/Modal'),
        AccountForm
    },
}
</script>

<style lang="scss" scoped>
.account-request {
    width: 100%;
    height: 100%;

    .control-wrapper {
        margin-top: 15px;
        flex: 1 1 auto;
        width: 100%;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .controls {
            display: flex;
            justify-content: flex-end;
            > *:not(:first-child) {
                margin-left: 10px;
            }

            .option {
                &:first-child {
                    width: 110px;
                }
            }
        }
    }

   /deep/ .id {
        width: 100px;
    }

    button {
        &:disabled {
            filter: grayscale(100%);
        }

        .icon {
            &.remote {
                height: 20px;
                width: 20px;
                filter: invert(59%) sepia(64%) saturate(455%) hue-rotate(125deg) brightness(98%) contrast(91%);
            }
        }

        &.edit {
            margin-right: 10px;
        }
    }
}
</style>